
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-f3ac1188&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Dashboard.v1.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Dashboard.v1.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-f3ac1188!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Dashboard.v1.vue"),
  /* scopeId */
  "data-v-f3ac1188",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/examples/Dashboard.v1.vue
// module id = 688
// module chunks = 0